// extracted by mini-css-extract-plugin
export default {"iconsContainer":"ContactButtonGroup_iconsContainer__BJ95B","icon":"ContactButtonGroup_icon__9Rv6d"};